import { Translate } from "@omni/types/utils/translate";
import { boolean } from "yup";

const ageCondition = boolean().oneOf(
    [true],
    () => () => (t: Translate) =>
        t("checkout.customerDetails.ageCondition.validation.input.required")
);
const partnerCondition = boolean().oneOf(
    [true],
    () => () => (t: Translate) =>
        t("checkout.customerDetails.partnerCondition.validation.input.required")
);

export const Conditions = {
    ageCondition: ageCondition,
    partnerCondition: partnerCondition
};
